import { render, staticRenderFns } from "./ElegirTipo.vue?vue&type=template&id=c26a7426&scoped=true"
import script from "./ElegirTipo.vue?vue&type=script&lang=js"
export * from "./ElegirTipo.vue?vue&type=script&lang=js"
import style0 from "./ElegirTipo.vue?vue&type=style&index=0&id=c26a7426&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26a7426",
  null
  
)

export default component.exports